export class UserInfoModal {
  appOrigin?: string;
  isRHProtegido?: boolean;

  constructor() {
    this.appOrigin = '';
    this.isRHProtegido = false;
  }
}
